import React from 'react';

export const SolidFileExcelIcon = ({
  size = 32,
  color = '#00723A',
}: {
  size?: number;
  color?: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.77002 1.32007L10 3.73965H7.77002V1.32007Z" fill={color} />
    <path
      d="M3 2C2.72386 2 2.5 2.22386 2.5 2.5V5.5H1.5V2.5C1.5 1.67157 2.17157 1 3 1H8.20711L10.5 3.29289V9.5C10.5 10.3284 9.82843 11 9 11H3C2.17157 11 1.5 10.3284 1.5 9.5V8.5H2.5V9.5C2.5 9.77614 2.72386 10 3 10H9C9.27614 10 9.5 9.77614 9.5 9.5V3.70711L7.79289 2H3Z"
      fill={color}
    />
    <path
      d="M1 5C1 4.72386 1.22386 4.5 1.5 4.5H10.5C10.7761 4.5 11 4.72386 11 5V9C11 9.27614 10.7761 9.5 10.5 9.5H1.5C1.22386 9.5 1 9.27614 1 9V5Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.85559 6H9.17559V7.68H10.2156V8H8.85559V6Z"
      fill="white"
    />
    <path d="M4.62336 6H4.94835L3.86503 8H3.54004L4.62336 6Z" fill="white" />
    <path d="M4.62336 8H4.94835L3.86503 6H3.54004L4.62336 8Z" fill="white" />
    <path
      d="M6.74771 6.15375C6.602 6.05636 6.4294 6 6.24436 6C5.72283 6 5.30005 6.44772 5.30005 7C5.30005 7.55228 5.72283 8 6.24436 8C6.4294 8 6.602 7.94364 6.74771 7.84625V7.4224C6.63008 7.57938 6.44835 7.68005 6.24441 7.68005C5.88977 7.68005 5.60228 7.37561 5.60228 7.00005C5.60228 6.6245 5.88977 6.32005 6.24441 6.32005C6.44835 6.32005 6.63008 6.42073 6.74771 6.5777V6.15375Z"
      fill="white"
    />
    <path d="M1.78003 6H2.10003V8H1.78003V6Z" fill="white" />
    <path d="M1.78003 6H3.18003V6.32H1.78003V6Z" fill="white" />
    <path d="M1.78003 7.67969H3.18003V7.99969L1.78003 8V7.67969Z" fill="white" />
    <path d="M1.78003 6.84H3.18003V7.16H1.78003V6.84Z" fill="white" />
    <path d="M7.10999 6H7.42999V8H7.10999V6Z" fill="white" />
    <path d="M7.10999 6H8.50999V6.32H7.10999V6Z" fill="white" />
    <path d="M7.10999 7.67969H8.50999V7.99969L7.10999 8V7.67969Z" fill="white" />
    <path d="M7.10999 6.84H8.50999V7.16H7.10999V6.84Z" fill="white" />
  </svg>
);
export const SolidFileExcelIconWeb = ({ size = 32 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M22.72 5.52051L28.6666 11.9727H22.72V5.52051Z" fill="#08AA5D" />
    <path
      d="M10 7.33366C9.26362 7.33366 8.66667 7.93061 8.66667 8.66699V16.667H6V8.66699C6 6.45785 7.79086 4.66699 10 4.66699H23.8856L30 10.7814V27.3337C30 29.5428 28.2091 31.3337 26 31.3337H10C7.79086 31.3337 6 29.5428 6 27.3337V24.667H8.66667V27.3337C8.66667 28.07 9.26362 28.667 10 28.667H26C26.7364 28.667 27.3333 28.07 27.3333 27.3337V11.8859L22.781 7.33366H10Z"
      fill="#08AA5D"
    />
    <path
      d="M4.66675 15.3333C4.66675 14.597 5.2637 14 6.00008 14H30.0001C30.7365 14 31.3334 14.597 31.3334 15.3333V26C31.3334 26.7364 30.7365 27.3333 30.0001 27.3333H6.00008C5.2637 27.3333 4.66675 26.7364 4.66675 26V15.3333Z"
      fill="#08AA5D"
    />
    <path d="M13.6268 17.333H14.7201L10.2134 23.9997H9.12012L13.6268 17.333Z" fill="white" />
    <path d="M13.6268 23.9997H14.7201L10.2135 17.333H9.12012L13.6268 23.9997Z" fill="white" />
    <path d="M16.1602 22.933H20.8206V23.9997H16.1602V22.933Z" fill="white" />
    <path d="M16.1602 17.333H17.2435V23.9997H16.1602V17.333Z" fill="white" />
    <path
      d="M22.6934 22.0658C22.6934 22.5445 23.0814 22.9325 23.56 22.9325H24.9639C25.4425 22.9325 25.8305 22.5445 25.8305 22.0658C25.8305 21.5872 25.4425 21.1992 24.9639 21.1992L23.56 21.1997C22.4923 21.1997 21.6267 20.3341 21.6267 19.2663C21.6267 18.1986 22.4923 17.333 23.56 17.333H24.9639C26.0316 17.333 26.8972 18.1986 26.8972 19.2663H25.8305C25.8305 18.7877 25.4425 18.3997 24.9639 18.3997H23.56C23.0814 18.3997 22.6934 18.7877 22.6934 19.2663C22.6934 19.745 23.0814 20.133 23.56 20.133L24.9639 20.1325C26.0316 20.1325 26.8972 20.9981 26.8972 22.0658C26.8972 23.1336 26.0316 23.9992 24.9639 23.9992H23.56C22.4923 23.9992 21.6267 23.1336 21.6267 22.0658H22.6934Z"
      fill="white"
    />
  </svg>
);

export const SolidFileMDIcon = ({
  size = 32,
  color = '#2FA794',
}: {
  size?: number;
  color?: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.77002 1.32007L10 3.73965H7.77002V1.32007Z" fill={color} />
    <path
      d="M3 2C2.72386 2 2.5 2.22386 2.5 2.5V5.5H1.5V2.5C1.5 1.67157 2.17157 1 3 1H8.20711L10.5 3.29289V9.5C10.5 10.3284 9.82843 11 9 11H3C2.17157 11 1.5 10.3284 1.5 9.5V8.5H2.5V9.5C2.5 9.77614 2.72386 10 3 10H9C9.27614 10 9.5 9.77614 9.5 9.5V3.70711L7.79289 2H3Z"
      fill={color}
    />
    <path
      d="M1 5C1 4.72386 1.22386 4.5 1.5 4.5H10.5C10.7761 4.5 11 4.72386 11 5V9C11 9.27614 10.7761 9.5 10.5 9.5H1.5C1.22386 9.5 1 9.27614 1 9V5Z"
      fill={color}
    />
    <path
      d="M6.79004 5.75V8.25H7.652C8.03509 8.25 8.32241 8.13796 8.52056 7.91387C8.7088 7.70028 8.80458 7.39566 8.80458 7C8.80458 6.60084 8.7088 6.29622 8.52056 6.08613C8.32241 5.86204 8.03509 5.75 7.652 5.75H6.79004ZM7.17643 6.10014H7.57934C7.87327 6.10014 8.08793 6.17017 8.22333 6.31373C8.35543 6.45378 8.42148 6.68487 8.42148 7C8.42148 7.30812 8.35543 7.53571 8.22333 7.68277C8.08793 7.82633 7.87327 7.89986 7.57934 7.89986H7.17643V6.10014Z"
      fill="white"
    />
    <path d="M3.18994 5.75H3.58994V8.25H3.18994V5.75Z" fill="white" />
    <path d="M3.18994 5.75H3.58994L4.68994 8.25H4.28994L3.18994 5.75Z" fill="white" />
    <path d="M5.78997 5.75H5.38997L4.28994 8.25H4.68994L5.78997 5.75Z" fill="white" />
    <path d="M5.38997 5.75H5.78997L5.78994 8.25H5.38994L5.38997 5.75Z" fill="white" />
  </svg>
);

export const SolidFileMDIconWeb = ({ size = 32 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M22.72 5.52051L28.6666 11.9727H22.72V5.52051Z" fill="#355491" />
    <path
      d="M10 7.33366C9.26362 7.33366 8.66667 7.93061 8.66667 8.66699V16.667H6V8.66699C6 6.45785 7.79086 4.66699 10 4.66699H23.8856L30 10.7814V27.3337C30 29.5428 28.2091 31.3337 26 31.3337H10C7.79086 31.3337 6 29.5428 6 27.3337V24.667H8.66667V27.3337C8.66667 28.07 9.26362 28.667 10 28.667H26C26.7364 28.667 27.3333 28.07 27.3333 27.3337V11.8859L22.781 7.33366H10Z"
      fill="#355491"
    />
    <path
      d="M4.66675 15.3333C4.66675 14.597 5.2637 14 6.00008 14H30.0001C30.7365 14 31.3334 14.597 31.3334 15.3333V26C31.3334 26.7364 30.7365 27.3333 30.0001 27.3333H6.00008C5.2637 27.3333 4.66675 26.7364 4.66675 26V15.3333Z"
      fill="#355491"
    />
    <path
      d="M20.1072 17.333V23.9997H22.4057C23.4273 23.9997 24.1935 23.7009 24.7219 23.1033C25.2239 22.5338 25.4793 21.7214 25.4793 20.6663C25.4793 19.6019 25.2239 18.7896 24.7219 18.2294C24.1935 17.6318 23.4273 17.333 22.4057 17.333H20.1072ZM21.1376 18.2667H22.212C22.9958 18.2667 23.5682 18.4535 23.9293 18.8363C24.2816 19.2098 24.4577 19.826 24.4577 20.6663C24.4577 21.488 24.2816 22.0949 23.9293 22.4871C23.5682 22.8699 22.9958 23.066 22.212 23.066H21.1376V18.2667Z"
      fill="white"
    />
    <path d="M10.5068 17.333H11.5735V23.9997H10.5068V17.333Z" fill="white" />
    <path d="M10.5068 17.333H11.5735L14.5068 23.9997H13.4402L10.5068 17.333Z" fill="white" />
    <path d="M17.4402 17.333H16.3736L13.4402 23.9997H14.5068L17.4402 17.333Z" fill="white" />
    <path d="M16.3736 17.333H17.4402L17.4402 23.9997H16.3735L16.3736 17.333Z" fill="white" />
  </svg>
);

export const SolidFileEPUBIcon = ({
  size = 32,
  color = '#2FA794',
}: {
  size?: number;
  color?: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.77002 1.32007L10 3.73965H7.77002V1.32007Z" fill={color} />
    <path
      d="M3 2C2.72386 2 2.5 2.22386 2.5 2.5V5.5H1.5V2.5C1.5 1.67157 2.17157 1 3 1H8.20711L10.5 3.29289V9.5C10.5 10.3284 9.82843 11 9 11H3C2.17157 11 1.5 10.3284 1.5 9.5V8.5H2.5V9.5C2.5 9.77614 2.72386 10 3 10H9C9.27614 10 9.5 9.77614 9.5 9.5V3.70711L7.79289 2H3Z"
      fill={color}
    />
    <path
      d="M1 5C1 4.72386 1.22386 4.5 1.5 4.5H10.5C10.7761 4.5 11 4.72386 11 5V9C11 9.27614 10.7761 9.5 10.5 9.5H1.5C1.22386 9.5 1 9.27614 1 9V5Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.44504 5.75V7.55C6.44504 7.71569 6.57936 7.85 6.74504 7.85H7.34504C7.51073 7.85 7.64504 7.71569 7.64504 7.55V5.75H8.04504V7.55C8.04504 7.9366 7.73164 8.25 7.34504 8.25H6.74504C6.35844 8.25 6.04504 7.9366 6.04504 7.55V5.75H6.44504Z"
      fill="white"
    />
    <path
      d="M3.70508 5.75V8.25H4.11351V7.29062H4.73139C5.33881 7.29062 5.64251 7.03151 5.64251 6.51681C5.64251 6.0056 5.33881 5.75 4.73838 5.75H3.70508ZM4.11351 6.10014H4.70696C4.88499 6.10014 5.01765 6.13165 5.10143 6.19818C5.18521 6.2612 5.23059 6.36625 5.23059 6.51681C5.23059 6.66737 5.1887 6.77591 5.10492 6.84244C5.02114 6.90546 4.88848 6.94048 4.70696 6.94048H4.11351V6.10014Z"
      fill="white"
    />
    <path d="M1.55505 5.75H1.95505V8.25H1.55505V5.75Z" fill="white" />
    <path d="M1.55505 5.75H3.30505V6.15H1.55505V5.75Z" fill="white" />
    <path d="M1.55505 7.84961H3.30505V8.24961L1.55505 8.25V7.84961Z" fill="white" />
    <path d="M1.55505 6.8H3.30505V7.2H1.55505V6.8Z" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.72007 7.1998H8.84507V7.8498H9.72007C9.89956 7.8498 10.0451 7.7043 10.0451 7.5248C10.0451 7.34531 9.89956 7.1998 9.72007 7.1998ZM8.44507 6.7998V8.2498H9.72007C10.1205 8.2498 10.4451 7.92521 10.4451 7.5248C10.4451 7.1244 10.1205 6.7998 9.72007 6.7998H8.44507Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.72007 6.15H8.84507V6.8L9.72007 6.7998C9.89956 6.7998 10.0451 6.65449 10.0451 6.475C10.0451 6.29551 9.89956 6.15 9.72007 6.15ZM8.44507 5.75V7.2L9.72007 7.1998C10.1205 7.1998 10.4451 6.87541 10.4451 6.475C10.4451 6.07459 10.1205 5.75 9.72007 5.75H8.44507Z"
      fill="white"
    />
  </svg>
);
export const SolidFilePPTIcon = ({
  size = 32,
  color = '#FF6E01',
}: {
  size?: number;
  color?: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.77002 1.32007L10 3.73965H7.77002V1.32007Z" fill={color} />
    <path
      d="M3 2C2.72386 2 2.5 2.22386 2.5 2.5V5.5H1.5V2.5C1.5 1.67157 2.17157 1 3 1H8.20711L10.5 3.29289V9.5C10.5 10.3284 9.82843 11 9 11H3C2.17157 11 1.5 10.3284 1.5 9.5V8.5H2.5V9.5C2.5 9.77614 2.72386 10 3 10H9C9.27614 10 9.5 9.77614 9.5 9.5V3.70711L7.79289 2H3Z"
      fill={color}
    />
    <path
      d="M1 5C1 4.72386 1.22386 4.5 1.5 4.5H10.5C10.7761 4.5 11 4.72386 11 5V9C11 9.27614 10.7761 9.5 10.5 9.5H1.5C1.22386 9.5 1 9.27614 1 9L1 5Z"
      fill={color}
    />
    <path
      d="M2.59998 5.75V8.25H3.00841V7.29062H3.62629C4.2337 7.29062 4.53741 7.03151 4.53741 6.51681C4.53741 6.0056 4.2337 5.75 3.63327 5.75H2.59998ZM3.00841 6.10014H3.60186C3.77989 6.10014 3.91254 6.13165 3.99632 6.19818C4.0801 6.2612 4.12549 6.36625 4.12549 6.51681C4.12549 6.66737 4.0836 6.77591 3.99981 6.84244C3.91603 6.90546 3.78338 6.94048 3.60186 6.94048H3.00841V6.10014Z"
      fill="white"
    />
    <path
      d="M5.03735 5.75V8.25H5.44579V7.29062H6.06367C6.67108 7.29062 6.97479 7.03151 6.97479 6.51681C6.97479 6.0056 6.67108 5.75 6.07065 5.75H5.03735ZM5.44579 6.10014H6.03923C6.21727 6.10014 6.34992 6.13165 6.4337 6.19818C6.51748 6.2612 6.56286 6.36625 6.56286 6.51681C6.56286 6.66737 6.52097 6.77591 6.43719 6.84244C6.35341 6.90546 6.22076 6.94048 6.03923 6.94048H5.44579V6.10014Z"
      fill="white"
    />
    <path d="M7.37988 5.75H9.4111V6.15H7.37988V5.75Z" fill="white" />
    <path d="M8.19237 5.91667H8.59861V8.25H8.19237V5.91667Z" fill="white" />
  </svg>
);

export const SolidFilePPTIconWeb = ({ size = 32 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M22.72 5.52051L28.6666 11.9727H22.72V5.52051Z" fill="#FF8C21" />
    <path
      d="M10 7.33366C9.26362 7.33366 8.66667 7.93061 8.66667 8.66699V16.667H6V8.66699C6 6.45785 7.79086 4.66699 10 4.66699H23.8856L30 10.7814V27.3337C30 29.5428 28.2091 31.3337 26 31.3337H10C7.79086 31.3337 6 29.5428 6 27.3337V24.667H8.66667V27.3337C8.66667 28.07 9.26362 28.667 10 28.667H26C26.7364 28.667 27.3333 28.07 27.3333 27.3337V11.8859L22.781 7.33366H10Z"
      fill="#FF8C21"
    />
    <path
      d="M4.66675 15.3333C4.66675 14.597 5.2637 14 6.00008 14H30.0001C30.7365 14 31.3334 14.597 31.3334 15.3333V26C31.3334 26.7364 30.7365 27.3333 30.0001 27.3333H6.00008C5.2637 27.3333 4.66675 26.7364 4.66675 26L4.66675 15.3333Z"
      fill="#FF8C21"
    />
    <path
      d="M8.93335 17.333V23.9997H10.0225V21.4413H11.6702C13.29 21.4413 14.0998 20.7504 14.0998 19.3778C14.0998 18.0146 13.29 17.333 11.6888 17.333H8.93335ZM10.0225 18.2667H11.605C12.0798 18.2667 12.4335 18.3507 12.6569 18.5282C12.8804 18.6962 13.0014 18.9763 13.0014 19.3778C13.0014 19.7793 12.8897 20.0688 12.6663 20.2462C12.4428 20.4142 12.0891 20.5076 11.605 20.5076H10.0225V18.2667Z"
      fill="white"
    />
    <path
      d="M15.4331 17.333V23.9997H16.5223V21.4413H18.1699C19.7897 21.4413 20.5996 20.7504 20.5996 19.3778C20.5996 18.0146 19.7897 17.333 18.1886 17.333H15.4331ZM16.5223 18.2667H18.1048C18.5795 18.2667 18.9333 18.3507 19.1567 18.5282C19.3801 18.6962 19.5011 18.9763 19.5011 19.3778C19.5011 19.7793 19.3894 20.0688 19.166 20.2462C18.9426 20.4142 18.5889 20.5076 18.1048 20.5076H16.5223V18.2667Z"
      fill="white"
    />
    <path d="M21.6799 17.333H27.0965V18.3997H21.6799V17.333Z" fill="white" />
    <path d="M23.8466 17.7775H24.9299V23.9997H23.8466V17.7775Z" fill="white" />
    <path
      d="M8.93335 17.333V23.9997H10.0225V21.4413H11.6702C13.29 21.4413 14.0998 20.7504 14.0998 19.3778C14.0998 18.0146 13.29 17.333 11.6888 17.333H8.93335ZM10.0225 18.2667H11.605C12.0798 18.2667 12.4335 18.3507 12.6569 18.5282C12.8804 18.6962 13.0014 18.9763 13.0014 19.3778C13.0014 19.7793 12.8897 20.0688 12.6663 20.2462C12.4428 20.4142 12.0891 20.5076 11.605 20.5076H10.0225V18.2667Z"
      fill="white"
    />
  </svg>
);
export const SolidFilePdfIcon = ({
  size = 12,
  color = '#F55762',
}: {
  size?: number;
  color?: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.77002 1.32007L10 3.73965H7.77002V1.32007Z" fill={color} />
    <path
      d="M3 2C2.72386 2 2.5 2.22386 2.5 2.5V5.5H1.5V2.5C1.5 1.67157 2.17157 1 3 1H8.20711L10.5 3.29289V9.5C10.5 10.3284 9.82843 11 9 11H3C2.17157 11 1.5 10.3284 1.5 9.5V8.5H2.5V9.5C2.5 9.77614 2.72386 10 3 10H9C9.27614 10 9.5 9.77614 9.5 9.5V3.70711L7.79289 2H3Z"
      fill={color}
    />
    <path
      d="M1 5C1 4.72386 1.22386 4.5 1.5 4.5H10.5C10.7761 4.5 11 4.72386 11 5V9C11 9.27614 10.7761 9.5 10.5 9.5H1.5C1.22386 9.5 1 9.27614 1 9L1 5Z"
      fill={color}
    />
    <path
      d="M7.72998 5.75V8.25H8.13841V7.14356H9.35673V6.79342H8.13841V6.10014H9.43003V5.75H7.72998Z"
      fill="white"
    />
    <path
      d="M5 5.75V8.25H5.91112C6.31606 8.25 6.61976 8.13795 6.82922 7.91387C7.0282 7.70028 7.12943 7.39566 7.12943 7C7.12943 6.60084 7.0282 6.29622 6.82922 6.08613C6.61976 5.86204 6.31606 5.75 5.91112 5.75H5ZM5.40843 6.10014H5.83432C6.14501 6.10014 6.37191 6.17017 6.51504 6.31373C6.65467 6.45378 6.72449 6.68487 6.72449 7C6.72449 7.30812 6.65467 7.53571 6.51504 7.68277C6.37191 7.82633 6.14501 7.89986 5.83432 7.89986H5.40843V6.10014Z"
      fill="white"
    />
    <path
      d="M2.56262 5.75V8.25H2.97105V7.29062H3.58894C4.19635 7.29062 4.50005 7.03151 4.50005 6.51681C4.50005 6.0056 4.19635 5.75 3.59592 5.75H2.56262ZM2.97105 6.10014H3.5645C3.74254 6.10014 3.87519 6.13165 3.95897 6.19818C4.04275 6.2612 4.08813 6.36625 4.08813 6.51681C4.08813 6.66737 4.04624 6.77591 3.96246 6.84244C3.87868 6.90546 3.74603 6.94048 3.5645 6.94048H2.97105V6.10014Z"
      fill="white"
    />
  </svg>
);

export const SolidFilePdfIconWeb = ({ size = 12 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M22.72 5.52051L28.6666 11.9727H22.72V5.52051Z" fill="#FE3666" />
    <path
      d="M10 7.33366C9.26362 7.33366 8.66667 7.93061 8.66667 8.66699V16.667H6V8.66699C6 6.45785 7.79086 4.66699 10 4.66699H23.8856L30 10.7814V27.3337C30 29.5428 28.2091 31.3337 26 31.3337H10C7.79086 31.3337 6 29.5428 6 27.3337V24.667H8.66667V27.3337C8.66667 28.07 9.26362 28.667 10 28.667H26C26.7364 28.667 27.3333 28.07 27.3333 27.3337V11.8859L22.781 7.33366H10Z"
      fill="#FE3666"
    />
    <path
      d="M4.66675 15.3333C4.66675 14.597 5.2637 14 6.00008 14H30.0001C30.7365 14 31.3334 14.597 31.3334 15.3333V26C31.3334 26.7364 30.7365 27.3333 30.0001 27.3333H6.00008C5.2637 27.3333 4.66675 26.7364 4.66675 26L4.66675 15.3333Z"
      fill="#FE3666"
    />
    <path
      d="M22.6133 17.333V23.9997H23.7024V21.0492H26.9513V20.1155H23.7024V18.2667H27.1468V17.333H22.6133Z"
      fill="white"
    />
    <path
      d="M15.3335 17.333V23.9997H17.7631C18.843 23.9997 19.6529 23.7009 20.2114 23.1033C20.742 22.5338 21.012 21.7214 21.012 20.6663C21.012 19.6019 20.742 18.7896 20.2114 18.2294C19.6529 17.6318 18.843 17.333 17.7631 17.333H15.3335ZM16.4226 18.2667H17.5583C18.3868 18.2667 18.9919 18.4535 19.3736 18.8363C19.746 19.2098 19.9321 19.826 19.9321 20.6663C19.9321 21.488 19.746 22.0949 19.3736 22.4871C18.9919 22.8699 18.3868 23.066 17.5583 23.066H16.4226V18.2667Z"
      fill="white"
    />
    <path
      d="M8.83374 17.333V23.9997H9.92289V21.4413H11.5706C13.1903 21.4413 14.0002 20.7504 14.0002 19.3778C14.0002 18.0146 13.1903 17.333 11.5892 17.333H8.83374ZM9.92289 18.2667H11.5054C11.9802 18.2667 12.3339 18.3507 12.5573 18.5282C12.7808 18.6962 12.9018 18.9763 12.9018 19.3778C12.9018 19.7793 12.7901 20.0688 12.5666 20.2462C12.3432 20.4142 11.9895 20.5076 11.5054 20.5076H9.92289V18.2667Z"
      fill="white"
    />
  </svg>
);

export const SolidFileTxtIcon = ({
  size = 12,
  color = '#08C99A',
}: {
  size?: number;
  color?: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.77002 1.32007L10 3.73965H7.77002V1.32007Z" fill={color} />
    <path
      d="M3 2C2.72386 2 2.5 2.22386 2.5 2.5V5.5H1.5V2.5C1.5 1.67157 2.17157 1 3 1H8.20711L10.5 3.29289V9.5C10.5 10.3284 9.82843 11 9 11H3C2.17157 11 1.5 10.3284 1.5 9.5V8.5H2.5V9.5C2.5 9.77614 2.72386 10 3 10H9C9.27614 10 9.5 9.77614 9.5 9.5V3.70711L7.79289 2H3Z"
      fill={color}
    />
    <path
      d="M1 5C1 4.72386 1.22386 4.5 1.5 4.5H10.5C10.7761 4.5 11 4.72386 11 5V9C11 9.27614 10.7761 9.5 10.5 9.5H1.5C1.22386 9.5 1 9.27614 1 9V5Z"
      fill={color}
    />
    <path d="M2.58997 5.75H4.62118V6.15H2.58997V5.75Z" fill="white" />
    <path d="M3.40245 5.91667H3.8087V8.25H3.40245V5.91667Z" fill="white" />
    <path d="M6.47414 5.75H6.88038L5.52624 8.25H5.12L6.47414 5.75Z" fill="white" />
    <path d="M6.47414 8.25H6.88038L5.52624 5.75H5.12L6.47414 8.25Z" fill="white" />
    <path d="M7.38 5.75H9.41122V6.15H7.38V5.75Z" fill="white" />
    <path d="M8.19249 5.91667H8.59874V8.25H8.19249V5.91667Z" fill="white" />
  </svg>
);

export const SolidFileTxtIconWeb = ({ size = 12 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M22.72 5.52051L28.6666 11.9727H22.72V5.52051Z" fill="#00B42A" />
    <path
      d="M10 7.33366C9.26362 7.33366 8.66667 7.93061 8.66667 8.66699V16.667H6V8.66699C6 6.45785 7.79086 4.66699 10 4.66699H23.8856L30 10.7814V27.3337C30 29.5428 28.2091 31.3337 26 31.3337H10C7.79086 31.3337 6 29.5428 6 27.3337V24.667H8.66667V27.3337C8.66667 28.07 9.26362 28.667 10 28.667H26C26.7364 28.667 27.3333 28.07 27.3333 27.3337V11.8859L22.781 7.33366H10Z"
      fill="#00B42A"
    />
    <path
      d="M4.66675 15.3333C4.66675 14.597 5.2637 14 6.00008 14H30.0001C30.7365 14 31.3334 14.597 31.3334 15.3333V26C31.3334 26.7364 30.7365 27.3333 30.0001 27.3333H6.00008C5.2637 27.3333 4.66675 26.7364 4.66675 26V15.3333Z"
      fill="#00B42A"
    />
    <path d="M19.7066 17.333H20.7999L16.2933 23.9997H15.2L19.7066 17.333Z" fill="white" />
    <path d="M19.7066 23.9997H20.7999L16.2933 17.333H15.2L19.7066 23.9997Z" fill="white" />
    <path d="M22.1333 17.333H27.5499V18.3997H22.1333V17.333Z" fill="white" />
    <path d="M24.2999 17.7775H25.3833V23.9997H24.2999V17.7775Z" fill="white" />
    <path d="M8.45337 17.333H13.87V18.3997H8.45337V17.333Z" fill="white" />
    <path d="M10.62 17.7775H11.7033V23.9997H10.62V17.7775Z" fill="white" />
  </svg>
);

export const SolidFileDocxIcon = ({
  size = 12,
  color = '#2C5796',
}: {
  size?: number;
  color?: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.77002 1.32007L10 3.73965H7.77002V1.32007Z" fill={color} />
    <path
      d="M3 2C2.72386 2 2.5 2.22386 2.5 2.5V5.5H1.5V2.5C1.5 1.67157 2.17157 1 3 1H8.20711L10.5 3.29289V9.5C10.5 10.3284 9.82843 11 9 11H3C2.17157 11 1.5 10.3284 1.5 9.5V8.5H2.5V9.5C2.5 9.77614 2.72386 10 3 10H9C9.27614 10 9.5 9.77614 9.5 9.5V3.70711L7.79289 2H3Z"
      fill={color}
    />
    <path
      d="M1 5C1 4.72386 1.22386 4.5 1.5 4.5H10.5C10.7761 4.5 11 4.72386 11 5V9C11 9.27614 10.7761 9.5 10.5 9.5H1.5C1.22386 9.5 1 9.27614 1 9V5Z"
      fill={color}
    />
    <path
      d="M1.58496 5.75V8.25H2.44692C2.83001 8.25 3.11733 8.13796 3.31548 7.91387C3.50373 7.70028 3.5995 7.39566 3.5995 7C3.5995 6.60084 3.50373 6.29622 3.31548 6.08613C3.11733 5.86204 2.83001 5.75 2.44692 5.75H1.58496ZM1.97136 6.10014H2.37426C2.66819 6.10014 2.88285 6.17017 3.01825 6.31373C3.15036 6.45378 3.21641 6.68487 3.21641 7C3.21641 7.30812 3.15036 7.53571 3.01825 7.68277C2.88285 7.82633 2.66819 7.89986 2.37426 7.89986H1.97136V6.10014Z"
      fill="white"
    />
    <path
      d="M8.25464 5.94218C8.07251 5.82045 7.85675 5.75 7.62546 5.75C6.97355 5.75 6.44507 6.30964 6.44507 7C6.44507 7.69036 6.97355 8.25 7.62546 8.25C7.85675 8.25 8.07251 8.17955 8.25464 8.05782V7.528C8.10761 7.72422 7.88044 7.85007 7.62552 7.85007C7.18222 7.85007 6.82286 7.46951 6.82286 7.00007C6.82286 6.53062 7.18222 6.15007 7.62552 6.15007C7.88044 6.15007 8.10761 6.27591 8.25464 6.47213V5.94218Z"
      fill="white"
    />
    <path d="M10.0092 5.75H10.4154L9.06127 8.25H8.65503L10.0092 5.75Z" fill="white" />
    <path d="M10.0092 8.25H10.4154L9.06127 5.75H8.65503L10.0092 8.25Z" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.018 5.75C4.45301 5.75 3.995 6.23502 3.995 6.83333V7.16667C3.995 7.76498 4.45301 8.25 5.018 8.25C5.58299 8.25 6.04101 7.76498 6.04101 7.16667V6.83333C6.04101 6.23502 5.58299 5.75 5.018 5.75ZM5.01809 6.15007C4.66172 6.15007 4.37281 6.456 4.37281 6.8334V7.16673C4.37281 7.54413 4.66172 7.85006 5.01809 7.85006C5.37447 7.85006 5.66338 7.54413 5.66338 7.16673V6.8334C5.66338 6.456 5.37447 6.15007 5.01809 6.15007Z"
      fill="white"
    />
  </svg>
);

export const SolidFileDocxIconWeb = ({ size = 12 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M22.72 5.52051L28.6666 11.9727H22.72V5.52051Z" fill="#0435AF" />
    <path
      d="M10 7.33366C9.26362 7.33366 8.66667 7.93061 8.66667 8.66699V16.667H6V8.66699C6 6.45785 7.79086 4.66699 10 4.66699H23.8856L30 10.7814V27.3337C30 29.5428 28.2091 31.3337 26 31.3337H10C7.79086 31.3337 6 29.5428 6 27.3337V24.667H8.66667V27.3337C8.66667 28.07 9.26362 28.667 10 28.667H26C26.7364 28.667 27.3333 28.07 27.3333 27.3337V11.8859L22.781 7.33366H10Z"
      fill="#0435AF"
    />
    <path
      d="M4.66675 15.3333C4.66675 14.597 5.2637 14 6.00008 14H30.0001C30.7365 14 31.3334 14.597 31.3334 15.3333V26C31.3334 26.7364 30.7365 27.3333 30.0001 27.3333H6.00008C5.2637 27.3333 4.66675 26.7364 4.66675 26V15.3333Z"
      fill="#0435AF"
    />
    <path
      d="M6.22681 17.333V23.9997H8.52536C9.54694 23.9997 10.3131 23.7009 10.8415 23.1033C11.3435 22.5338 11.5989 21.7214 11.5989 20.6663C11.5989 19.6019 11.3435 18.7896 10.8415 18.2294C10.3131 17.6318 9.54694 17.333 8.52536 17.333H6.22681ZM7.25719 18.2667H8.33161C9.11541 18.2667 9.68785 18.4535 10.0489 18.8363C10.4012 19.2098 10.5773 19.826 10.5773 20.6663C10.5773 21.488 10.4012 22.0949 10.0489 22.4871C9.68785 22.8699 9.11541 23.066 8.33161 23.066H7.25719V18.2667Z"
      fill="white"
    />
    <path
      d="M24.0125 17.8455C23.5269 17.5209 22.9515 17.333 22.3347 17.333C20.5963 17.333 19.187 18.8254 19.187 20.6663C19.187 22.5073 20.5963 23.9997 22.3347 23.9997C22.9515 23.9997 23.5269 23.8118 24.0125 23.4872V22.0743C23.6204 22.5976 23.0147 22.9332 22.3349 22.9332C21.1528 22.9332 20.1944 21.9184 20.1944 20.6665C20.1944 19.4147 21.1528 18.3998 22.3349 18.3998C23.0147 18.3998 23.6204 18.7354 24.0125 19.2587V17.8455Z"
      fill="white"
    />
    <path d="M28.6914 17.333H29.7747L26.1636 23.9997H25.0803L28.6914 17.333Z" fill="white" />
    <path d="M28.6914 23.9997H29.7747L26.1636 17.333H25.0803L28.6914 23.9997Z" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.3816 17.333C13.8749 17.333 12.6536 18.6264 12.6536 20.2219V21.1108C12.6536 22.7063 13.8749 23.9997 15.3816 23.9997C16.8882 23.9997 18.1096 22.7063 18.1096 21.1108V20.2219C18.1096 18.6264 16.8882 17.333 15.3816 17.333ZM15.3818 18.3998C14.4315 18.3998 13.6611 19.2157 13.6611 20.2221V21.111C13.6611 22.1173 14.4315 22.9332 15.3818 22.9332C16.3322 22.9332 17.1026 22.1173 17.1026 21.111V20.2221C17.1026 19.2157 16.3322 18.3998 15.3818 18.3998Z"
      fill="white"
    />
  </svg>
);

export const SolidFileDocIcon = ({
  size = 12,
  color = '#477BFB',
}: {
  size?: number;
  color?: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.77002 1.32007L10 3.73965H7.77002V1.32007Z" fill={color} />
    <path
      d="M3 2C2.72386 2 2.5 2.22386 2.5 2.5V5.5H1.5V2.5C1.5 1.67157 2.17157 1 3 1H8.20711L10.5 3.29289V9.5C10.5 10.3284 9.82843 11 9 11H3C2.17157 11 1.5 10.3284 1.5 9.5V8.5H2.5V9.5C2.5 9.77614 2.72386 10 3 10H9C9.27614 10 9.5 9.77614 9.5 9.5V3.70711L7.79289 2H3Z"
      fill={color}
    />
    <path
      d="M1 5C1 4.72386 1.22386 4.5 1.5 4.5H10.5C10.7761 4.5 11 4.72386 11 5V9C11 9.27614 10.7761 9.5 10.5 9.5H1.5C1.22386 9.5 1 9.27614 1 9V5Z"
      fill={color}
    />
    <path
      d="M2.56006 5.75V8.25H3.42202C3.80511 8.25 4.09243 8.13796 4.29058 7.91387C4.47882 7.70028 4.5746 7.39566 4.5746 7C4.5746 6.60084 4.47882 6.29622 4.29058 6.08613C4.09243 5.86204 3.80511 5.75 3.42202 5.75H2.56006ZM2.94645 6.10014H3.34936C3.64329 6.10014 3.85795 6.17017 3.99335 6.31373C4.12545 6.45378 4.1915 6.68487 4.1915 7C4.1915 7.30812 4.12545 7.53571 3.99335 7.68277C3.85795 7.82633 3.64329 7.89986 3.34936 7.89986H2.94645V6.10014Z"
      fill="white"
    />
    <path
      d="M9.42969 5.94218C9.24756 5.82045 9.0318 5.75 8.80051 5.75C8.1486 5.75 7.62012 6.30964 7.62012 7C7.62012 7.69036 8.1486 8.25 8.80051 8.25C9.0318 8.25 9.24756 8.17955 9.42969 8.05782V7.528C9.28265 7.72422 9.05549 7.85007 8.80057 7.85007C8.35727 7.85007 7.9979 7.46951 7.9979 7.00007C7.9979 6.53062 8.35727 6.15007 8.80057 6.15007C9.05549 6.15007 9.28265 6.27591 9.42969 6.47213V5.94218Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.09308 5.75C5.52808 5.75 5.07007 6.23502 5.07007 6.83333V7.16667C5.07007 7.76498 5.52808 8.25 6.09308 8.25C6.65807 8.25 7.11608 7.76498 7.11608 7.16667V6.83333C7.11608 6.23502 6.65807 5.75 6.09308 5.75ZM6.09317 6.15007C5.73679 6.15007 5.44789 6.456 5.44789 6.8334V7.16673C5.44789 7.54413 5.73679 7.85006 6.09317 7.85006C6.44955 7.85006 6.73845 7.54413 6.73845 7.16673V6.8334C6.73845 6.456 6.44955 6.15007 6.09317 6.15007Z"
      fill="white"
    />
  </svg>
);

export const SolidFileDocIconWeb = ({ size = 12 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M22.72 5.52051L28.6666 11.9727H22.72V5.52051Z" fill="#1E5EFA" />
    <path
      d="M10 7.33366C9.26362 7.33366 8.66667 7.93061 8.66667 8.66699V16.667H6V8.66699C6 6.45785 7.79086 4.66699 10 4.66699H23.8856L30 10.7814V27.3337C30 29.5428 28.2091 31.3337 26 31.3337H10C7.79086 31.3337 6 29.5428 6 27.3337V24.667H8.66667V27.3337C8.66667 28.07 9.26362 28.667 10 28.667H26C26.7364 28.667 27.3333 28.07 27.3333 27.3337V11.8859L22.781 7.33366H10Z"
      fill="#1E5EFA"
    />
    <path
      d="M4.66675 15.3333C4.66675 14.597 5.2637 14 6.00008 14H30.0001C30.7365 14 31.3334 14.597 31.3334 15.3333V26C31.3334 26.7364 30.7365 27.3333 30.0001 27.3333H6.00008C5.2637 27.3333 4.66675 26.7364 4.66675 26V15.3333Z"
      fill="#1E5EFA"
    />
    <path
      d="M8.82666 17.333V23.9997H11.1252C12.1468 23.9997 12.913 23.7009 13.4414 23.1033C13.9434 22.5338 14.1988 21.7214 14.1988 20.6663C14.1988 19.6019 13.9434 18.7896 13.4414 18.2294C12.913 17.6318 12.1468 17.333 11.1252 17.333H8.82666ZM9.85705 18.2667H10.9315C11.7153 18.2667 12.2877 18.4535 12.6488 18.8363C13.001 19.2098 13.1772 19.826 13.1772 20.6663C13.1772 21.488 13.001 22.0949 12.6488 22.4871C12.2877 22.8699 11.7153 23.066 10.9315 23.066H9.85705V18.2667Z"
      fill="white"
    />
    <path
      d="M27.1456 17.8455C26.6599 17.5209 26.0846 17.333 25.4678 17.333C23.7293 17.333 22.3201 18.8254 22.3201 20.6663C22.3201 22.5073 23.7293 23.9997 25.4678 23.9997C26.0846 23.9997 26.6599 23.8118 27.1456 23.4872V22.0743C26.7535 22.5976 26.1477 22.9332 25.4679 22.9332C24.2858 22.9332 23.3275 21.9184 23.3275 20.6665C23.3275 19.4147 24.2858 18.3998 25.4679 18.3998C26.1477 18.3998 26.7535 18.7354 27.1456 19.2587V17.8455Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.248 17.333C16.7414 17.333 15.52 18.6264 15.52 20.2219V21.1108C15.52 22.7063 16.7414 23.9997 18.248 23.9997C19.7547 23.9997 20.9761 22.7063 20.9761 21.1108V20.2219C20.9761 18.6264 19.7547 17.333 18.248 17.333ZM18.2483 18.3998C17.2979 18.3998 16.5275 19.2157 16.5275 20.2221V21.111C16.5275 22.1173 17.2979 22.9332 18.2483 22.9332C19.1986 22.9332 19.969 22.1173 19.969 21.111V20.2221C19.969 19.2157 19.1986 18.3998 18.2483 18.3998Z"
      fill="white"
    />
  </svg>
);

export const SolidFileFailIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.7199 3.52026L26.6666 9.97247H20.7199V3.52026Z" fill="#999999" />
    <path
      d="M8 5.33341C7.26362 5.33341 6.66667 5.93037 6.66667 6.66675V14.6667H4V6.66675C4 4.45761 5.79086 2.66675 8 2.66675H21.8856L28 8.78113V25.3334C28 27.5426 26.2091 29.3334 24 29.3334H8C5.79086 29.3334 4 27.5426 4 25.3334V22.6667H6.66667V25.3334C6.66667 26.0698 7.26362 26.6667 8 26.6667H24C24.7364 26.6667 25.3333 26.0698 25.3333 25.3334V9.8857L20.781 5.33341H8Z"
      fill="#999999"
    />
    <path
      d="M2.66666 13.3333C2.66666 12.597 3.26361 12 3.99999 12H28C28.7364 12 29.3333 12.597 29.3333 13.3333V24C29.3333 24.7364 28.7364 25.3333 28 25.3333H3.99999C3.26361 25.3333 2.66666 24.7364 2.66666 24L2.66666 13.3333Z"
      fill="#999999"
    />
    <path
      d="M16.1659 14.96C16.6427 14.96 17.0224 15.3428 16.9986 15.7995L16.8753 18.2415C16.852 18.6888 16.467 19.04 16 19.04C15.5329 19.04 15.1479 18.6888 15.1246 18.2415L15.0018 15.7995C14.978 15.3428 15.3577 14.96 15.8345 14.96L16.1659 14.96Z"
      fill="white"
    />
    <path
      d="M16.9995 21.3723C16.9995 21.9243 16.552 22.3717 16 22.3717C15.448 22.3717 15.0005 21.9243 15.0005 21.3723C15.0005 20.8203 15.448 20.3728 16 20.3728C16.552 20.3728 16.9995 20.8203 16.9995 21.3723Z"
      fill="white"
    />
  </svg>
);

export const SolidFileFailIconWeb = ({ size = 32 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M22.72 5.52051L28.6666 11.9727H22.72V5.52051Z" fill="#9A9A9A" />
    <path
      d="M10 7.33366C9.26362 7.33366 8.66667 7.93061 8.66667 8.66699V16.667H6V8.66699C6 6.45785 7.79086 4.66699 10 4.66699H23.8856L30 10.7814V27.3337C30 29.5428 28.2091 31.3337 26 31.3337H10C7.79086 31.3337 6 29.5428 6 27.3337V24.667H8.66667V27.3337C8.66667 28.07 9.26362 28.667 10 28.667H26C26.7364 28.667 27.3333 28.07 27.3333 27.3337V11.8859L22.781 7.33366H10Z"
      fill="#9A9A9A"
    />
    <path
      d="M4.66675 15.3333C4.66675 14.597 5.2637 14 6.00008 14H30.0001C30.7365 14 31.3334 14.597 31.3334 15.3333V26C31.3334 26.7364 30.7365 27.3333 30.0001 27.3333H6.00008C5.2637 27.3333 4.66675 26.7364 4.66675 26L4.66675 15.3333Z"
      fill="#9A9A9A"
    />
    <path
      d="M18.166 16.96C18.6428 16.96 19.0225 17.3428 18.9987 17.7995L18.8755 20.2415C18.8521 20.6888 18.4671 21.04 18.0001 21.04C17.533 21.04 17.148 20.6888 17.1247 20.2415L17.0019 17.7995C16.9781 17.3428 17.3578 16.96 17.8346 16.96L18.166 16.96Z"
      fill="white"
    />
    <path
      d="M18.9995 23.3725C18.9995 23.9245 18.5521 24.372 18.0001 24.372C17.4481 24.372 17.0006 23.9245 17.0006 23.3725C17.0006 22.8205 17.4481 22.373 18.0001 22.373C18.5521 22.373 18.9995 22.8205 18.9995 23.3725Z"
      fill="white"
    />
  </svg>
);

export const SolidFileUnknowIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.7199 3.52026L26.6666 9.97247H20.7199V3.52026Z" fill="#999999" />
    <path
      d="M8 5.33341C7.26362 5.33341 6.66667 5.93037 6.66667 6.66675V14.6667H4V6.66675C4 4.45761 5.79086 2.66675 8 2.66675H21.8856L28 8.78113V25.3334C28 27.5426 26.2091 29.3334 24 29.3334H8C5.79086 29.3334 4 27.5426 4 25.3334V22.6667H6.66667V25.3334C6.66667 26.0698 7.26362 26.6667 8 26.6667H24C24.7364 26.6667 25.3333 26.0698 25.3333 25.3334V9.8857L20.781 5.33341H8Z"
      fill="#999999"
    />
    <path
      d="M2.66666 13.3333C2.66666 12.597 3.26361 12 3.99999 12H28C28.7364 12 29.3333 12.597 29.3333 13.3333V24C29.3333 24.7364 28.7364 25.3333 28 25.3333H3.99999C3.26361 25.3333 2.66666 24.7364 2.66666 24L2.66666 13.3333Z"
      fill="#999999"
    />
    <g clipPath="url(#clip0_801_11242)">
      <path
        d="M16.6667 21.9999C16.6667 22.3681 16.3682 22.6666 16 22.6666C15.6318 22.6666 15.3333 22.3681 15.3333 21.9999C15.3333 21.6317 15.6318 21.3333 16 21.3333C16.3682 21.3333 16.6667 21.6317 16.6667 21.9999Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 15.7334C15.2388 15.7334 14.6667 16.3148 14.6667 16.9779C14.6667 17.2724 14.4279 17.5112 14.1333 17.5112C13.8388 17.5112 13.6 17.2724 13.6 16.9779C13.6 15.6772 14.6993 14.6667 16 14.6667C17.3007 14.6667 18.4 15.6772 18.4 16.9779C18.4 17.6069 18.195 18.138 17.6929 18.6162C17.5373 18.7644 17.3797 18.8947 17.2443 19.0066C17.2238 19.0236 17.2037 19.0402 17.1843 19.0563C17.0295 19.1848 16.9109 19.2876 16.8142 19.3946C16.6468 19.5797 16.5333 19.7863 16.5333 20.1779C16.5333 20.4724 16.2946 20.7112 16 20.7112C15.7055 20.7112 15.4667 20.4724 15.4667 20.1779C15.4667 19.5043 15.6905 19.0468 16.023 18.6791C16.1763 18.5097 16.3483 18.364 16.5029 18.2356C16.5247 18.2176 16.5461 18.1998 16.5674 18.1822C16.7041 18.0691 16.8308 17.9642 16.9573 17.8438C17.2405 17.5741 17.3333 17.3256 17.3333 16.9779C17.3333 16.3148 16.7612 15.7334 16 15.7334Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_801_11242">
        <rect width="5.33333" height="8" fill="white" transform="translate(13.3333 14.6667)" />
      </clipPath>
    </defs>
  </svg>
);
